import { takeEvery } from 'modules/typed-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionStockJewelriesGet } from './actions';

export const sagasStockJewelries = [
  takeEvery([actionStockJewelriesGet.rejected], workerErrorNotifyThunk),
];
